module.exports = __webpack_public_path__ + "../resources/img/main_visual.fd6f61a3.png";